<template>
  <div id="app">
    <WebNav />
    <router-view />
    <IndexFooter />
  </div>
</template>

<script>
import WebNav from '@/components/WebNav.vue'
import IndexFooter from '@/components/IndexFooter.vue'

export default {
  name: 'App',
  components: {
    WebNav,
    IndexFooter
  }
}
</script>

<style>


* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* body {
  font-family: Arial, "黑体", sans-serif;
}

#app {
  width: 100%;
  overflow: hidden;
} */
</style>
